module.exports = __webpack_public_path__ + "static/media/ic-close-plain.8b2fada7.svg";